import IconLayoutModule from '@apollo/icons/default/IconLayoutModule.svg';
import { Button } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

import { insightsRouteConfig } from 'src/app/graph/routes';
import { WrapMaybe } from 'src/components/wrapMaybe/WrapMaybe';
import { useInsightsFilter } from 'src/hooks/useInsightsFilter';
import Config from 'src/lib/config';

export const OperationsOverviewButton = () => {
  const { hasActiveFilters, resetToDefaultLocation } = useInsightsFilter({
    [Config.queryParameters.SelectedQueryId]: undefined,
    [Config.queryParameters.SelectedQueryName]: undefined,
    [Config.queryParameters.SelectedTraceId]: undefined,
    [Config.queryParameters.SelectedDurationBucket]: undefined,
  });

  const isSelected = !hasActiveFilters;

  return (
    <WrapMaybe
      element={<Link to={resetToDefaultLocation(insightsRouteConfig)} />}
      on={!isSelected}
    >
      <Button
        variant="secondary"
        className={classnames(
          'mb-4 w-full justify-start',
          isSelected && 'bg-btn-secondary-selected text-primary',
        )}
        leftIcon={<IconLayoutModule />}
      >
        Overview
      </Button>
    </WrapMaybe>
  );
};
